import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/operators';
import { AppConfig, ConfigService } from './services/config/config.service';

export type AllTranslations = Record<string, Record<string, string>>;

export class CustomTranslateHttpLoader implements TranslateLoader {
  private allTranslations: Observable<AllTranslations> | null = null;
  private fallbackUrl = './lang/%%-web.json';
  constructor(private http: HttpClient, private configService: ConfigService) {}

  /**
   * Gets the translations from the server
   */
  public getTranslation(lang: string) {
    this.allTranslations = this.getTranslations(lang, this.configService.applicationConfig);
    return this.allTranslations;
  }

  private getTranslations(lang: string, appConfig: AppConfig) {
    let translateFileUrl;
    const fallbackUrl = this.fallbackUrl.replace('%%', lang);
    if (appConfig.staticContentURL) {
      //When you want to test with local translations, put this as false.
      translateFileUrl = `${appConfig.staticContentURL}/${lang}-smarttvs.json`; // TODO change to -smarttvs
      // translateFileUrl = null;
    } else {
      translateFileUrl = fallbackUrl;
    }
    return this.http.get<AllTranslations>(translateFileUrl).pipe(catchError(() => this.http.get<AllTranslations>(fallbackUrl)));
  }
}
